// import { tranDomains } from "@/constants/domain.config";

export const speakText = (text: string) => {
  // const { hostName } = useHostName();
  // if (tranDomains.includes(hostName)) {
  //   return;
  // }
  if ("speechSynthesis" in window) {
    // console.log(text);
    const utterance = new SpeechSynthesisUtterance(text);
    // 设置语言（可选）
    // utterance.lang = "zh-CN"; // 中文
    window.speechSynthesis.speak(utterance);
  } else {
    console.log("Speech synthesis is not supported in this browser.");
  }
};
